import {AbsctractValidator} from "./AbstractValidator";

export class RequiredValidator extends AbsctractValidator {
    isValid() {
        if(this.input && typeof this.input === "object") {
            if(Object.keys(this.input).length === 0) {
                return false;
            }
            for(var i in this.input) {
                if(this.input[i].value === null || this.input[i].value === undefined ||  this.input[i].value === "") {
                    return false;
                }
            }
        }
        return this.input !== null && this.input !== undefined && this.input !== "";
    }
    message() {
        if(this.input && typeof this.input === "object") {
            if(Object.keys(this.input).length === 0) {
                return "Campo obrigatório (objecto vazio)";
            }
            for(var i in this.input) {
                if(this.input[i].value === null || this.input[i].value === undefined) {
                    return "Campo " + this.input[i].id +  " obrigatório";
                }
            }
        }
        return !this.isValid() ? "Campo obrigatório" : "OK";
    }
}




// WEBPACK FOOTER //
// ./src/validator/RequiredValidators.js